window.$ = window.jQuery = require('jquery/dist/jquery.min');
require('bootstrap/dist/js/bootstrap.min');
require('popper.js/dist/popper.min');
import 'inputmask';

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
UIkit.use(Icons);

//------------Animao Home-------------
window.AOS = require('AOS');
AOS.init();


// ------------------------------------------------------ Inputmask------------------------------------------------------
import "inputmask";
//Inputmask para todo os input // npm install jquery.inputmask  ||  npm i inputmask
let elementos  = document.getElementsByTagName('input');
if(elementos ) Inputmask().mask(elementos);

// -----------------------------------------------------------BOTAO NAVBAR-TOPO ------------------------------------

$(window).scroll(function () {
    if ($(this).scrollTop() > 50) {
        $('#back-to-top').fadeIn();
    } else {
        $('#back-to-top').fadeOut();
    }
});

// ------------------------------------------------------ CALCULADORA ------------------------------------------------

if (document.getElementById('iniciaCalculadora')) {

    $("#calcs").on("click", function () {

        let calcs = $('#calcs').val();
        let largJuntaD = document.getElementById('largJunta');
        let valor2 = document.getElementById('val2');
        let valor3 = document.getElementById('val3');
        let valor5 = document.getElementById('val5');
        //bloqueia "Largura da junta" para valor 2

            if (calcs === '3') {
                largJuntaD.value = '2'; // Seta valor quando selecionado
                largJuntaD.disabled = true;
            } else if (calcs === '1' || calcs === '2') {
                largJuntaD.disabled = false;
                valor3.style.display = 'flex';
            } else if (calcs === '4'){
                largJuntaD.disabled = false;
                largJuntaD.value = '5'; // Seta valor quando selecionado
                valor3.style.display = 'none';
                largJuntaD.disabled = true;
            }

    })
    //botao calcular
    $("#calcular").on("click", function () {

        let calcs = $('#calcs').val();
        let larg = $('#larg').val();
        let altu = $('#altu').val();
        let largJunta = $('#largJunta').val();
        let espRev = $('#espRev').val();
        let areaTotal = $('#areaTotal').val();

        //Tranforma em numero inteiro
        larg = parseInt(larg)
        altu = parseInt(altu)

        if (calcs === '1') {

            let somaLarAlt = larg + altu;
            somaLarAlt = parseInt(somaLarAlt);

            if (somaLarAlt <= 60) {
                areaTotal = (areaTotal / 4)
                let totalSaco = areaTotal.toFixed(2)
                document.getElementById('resulFinal').innerHTML = '<div class="py-2">' + 'CONSUMO MÉDIO: ' + Math.ceil(totalSaco) + ' saco(s)' + '</div>';

            } else {
                areaTotal = areaTotal / 2.5;
                let totalSaco = areaTotal.toFixed(2)
                document.getElementById('resulFinal').innerHTML = '<div class="py-2">' + 'CONSUMO MÉDIO: ' + Math.ceil(totalSaco) + ' saco(s)' + '</div>';
            }

        } else if (calcs === '2') {

            // let CL = ((larg * 10 + altu * 10) * espRev * largJunta * 1.58) / (larg * 10 * altu * 10);
            let RES = 0;

            if (largJunta === '2'){
                 RES = areaTotal * 0.250;
            }else if (largJunta === '3'){
                 RES = areaTotal * 0.350;
            }else if (largJunta === '5'){
                 RES = areaTotal * 0.450;
            }

            RES = parseFloat(RES.toFixed(2));

            document.getElementById('resulFinal').innerHTML = '<div class="py-2">' + 'CONSUMO MÉDIO: ' + RES + ' kg' + '</div>';

        } else if (calcs === '3') {

            let RES;

            RES = areaTotal * 0.250;

            RES = parseFloat(RES.toFixed(2));

            document.getElementById('resulFinal').innerHTML = '<div class="py-2">' + 'CONSUMO MÉDIO: ' + RES + ' kg' + '</div>';

        } else if (calcs === '4') {

            let CL = ((larg * 10 + altu * 10) * espRev * largJunta * 1.58) / (larg * 10 * altu * 10);
            let RES = CL * areaTotal;
            RES = parseFloat(RES.toFixed(2));
            let asseRejunta = (8 * areaTotal);

            document.getElementById('resulFinal').innerHTML = '<div class="py-2">' + 'Assenta e Rejunta: ' + asseRejunta + 'kg' + '<br><br>' + 'Rejunte: ' + RES  + 'kg' +'</div>';

        } else if (calcs === 'Escolha') {

            alert('Selecionar "Tipo de produto:"');

        }
    });
}

// --------------------------- DEFAULT -----------------------
$(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip({
        html: true
    });
    $('.toast').toast('show');


    if ($('table').length) {
        $('table').DataTable({
            "autoWidth": true,
            "info": true,
            "ordering": true,
            "pagingType": "full_numbers",
            "language": {
                "lengthMenu": "Mostrar _MENU_ registro por página",
                "zeroRecords": "Nada encontrado - Desculpe",
                "info": "Mostrando página _PAGE_ de _PAGES_",
                "infoEmpty": "Nenhum registro encontrado",
                "infoFiltered": "(Filtrado de _MAX_ registros totais)",
                "search": "Busca",
                "paginate": {
                    "next": "<i class='fa fa-angle-right' aria-hidden='true'></i>",
                    "last": "<i class='fa fa-angle-double-right' aria-hidden='true'></i>",
                    "first": "<i class='fa fa-angle-double-left' aria-hidden='true'></i>",
                    "previous": "<i class='fa fa-angle-left' aria-hidden='true'></i>"
                }
            }
        });
    }

    /// -------------------------------------------------Sidebar------------------------------------------------------------
    $("#menu-toggle").click(function (e) {
        e.preventDefault();
        $("#wrapper").toggleClass("toggled");
    });

    // ------------------------------------------------Password View----------------------------------------------------
    $("#show_hide_password").on('click', function (event) {
        event.preventDefault();
        if ($('#password').attr("type") == "text") {
            $('#password').attr('type', 'password');
            $('#password-confirm').attr('type', 'password');
            $('#show_hide_password i').removeClass("fa-eye");
            $('#show_hide_password i').addClass("fa-eye-slash");
        } else if ($('#password').attr("type") == "password") {
            $('#password').attr('type', 'text');
            $('#password-confirm').attr('type', 'text');
            $('#show_hide_password i').removeClass("fa-eye-slash");
            $('#show_hide_password i').addClass("fa-eye");
        }
    });

    $('.file-input').on('change', function () {

        let filesCount = $(this)[0].files.length;
        let textbox = $(this).prev();

        if (filesCount === 1) {
            let fileName = $(this).val().split('\\').pop();
            textbox.text(fileName);
        } else {
            textbox.text(filesCount + ' files selected');
        }

        if (typeof (FileReader) != "undefined") {
            let dvPreview = $("#divImageMediaPreview");
            dvPreview.html("");
            $($(this)[0].files).each(function () {
                let file = $(this);
                let reader = new FileReader();
                reader.onload = function (e) {
                    let img = $("<img />");
                    img.addClass('img-fluid figure-img img-thumbnail');
                    img.attr("style", "width: 200px; height:150px");
                    img.attr("src", e.target.result);
                    dvPreview.append(img);
                }
                reader.readAsDataURL(file[0]);
            });
        } else {
            alert("This browser does not support HTML5 FileReader.");
        }
    });

    // ------------------------------------------------Button Admin Upload--------------------------------------------------
    $('#btnUpload').on('click', function () {
        $('#btnUpload').hide();
        $('#btnUploadOn').slideDown('fast');
    })

    // --------------------------------------------------------Modal Retorno Busca------------------------------------------
    $('#emailHelp').modal('show');
    // $('#emailHelpClose').on('click', function (){
    //     $("#emailHelp").modal('hide');
    // });

});

// ------------------------------------------------Mascaras----------------------------------------------------
/* Mask Input */

let cep = document.getElementById('cep');
let phone = document.getElementById('telefone');
// let number = document.getElementById('cod_ordem');
if(cep) Inputmask({"mask": "99999-999"}).mask(cep);
if(phone) Inputmask({"mask": "99 9999-99999"}).mask(phone);
// if(number) Inputmask({"mask": "999"}).mask(number);



